import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const $slider = $('.masthead-carousel .masthead-carousel__main-slides-wrapper .slides');
	const slideCount = $slider.children().length;
	
	// Fallback: show slides if Slick fails to initialize
	setTimeout(() => {
		if (!$slider.hasClass('slick-initialized')) {
			$slider.addClass('js-failed');
		}
	}, 3000);
	
	$slider.slick({
		slidesToShow: 4,
		arrows: false,
		arrowsPlacement: 'afterSlides',
		appendArrows: $('.masthead-carousel-custom-container .custom-arrows'),
		appendDots: $('.masthead-carousel-custom-container .custom-dots'),
		dots: true,
		centerMode: true,
		infinite: true,
		speed: 600,
		cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
		useTransform: true,
		waitForAnimate: true,
		autoplay: true,
		autoplaySpeed: 3500,

		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false
				}
			}
		]
	});
})
